import React from 'react';

var listItemAvatarContextDefaults = {
    size: 'medium',
};
var ListItemAvatarContext = React.createContext(listItemAvatarContextDefaults);
var useListItemAvatarContext = function () { return React.useContext(ListItemAvatarContext); };

export { ListItemAvatarContext as L, listItemAvatarContextDefaults as l, useListItemAvatarContext as u };
